import { Button, ButtonVariant, IconConfirmationCircle } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { usePlaidMultiLinkContext } from '../plaid-multi-link-context/plaid-multi-link-context'

/**
 * Success component for Plaid Multi Link flow
 * Now reads success type and handlers from context
 */
export const PlaidSuccess: FC = () => {
  const { t } = useTranslation('features-external-accounts')
  const { currentSuccessType, closeModal } = usePlaidMultiLinkContext()

  return currentSuccessType ? (
    <div
      className="flex flex-col"
      data-testid="plaid-multi-link-success"
      role="alert"
      aria-live="polite"
      aria-labelledby="success-title"
    >
      <div className="flex flex-col mb-sm w-full">
        <IconConfirmationCircle className="mb-sm" />
        <p id="success-title" className="typo-primary-2xl-light text-text-header-success">
          {t(`plaid_multi_link.success.title.${currentSuccessType}`)}
        </p>
      </div>
      <p className="mb-lg">{t(`plaid_multi_link.success.message.${currentSuccessType}`)}</p>
      <Button
        variant={ButtonVariant.Primary}
        className="w-full"
        data-testid="plaid-multi-link-continue-button"
        onClick={closeModal}
        aria-describedby="success-title"
      >
        {t('plaid_multi_link.continue')}
      </Button>
    </div>
  ) : null
}
